module.exports = __webpack_public_path__ + "img/frame (156).e6e6db15.jpg";